import { Popper } from '@zillow/constellation';
import { Box, Heading } from '@zillow/constellation-10';
import { TourStatusForZcheduler } from '@zg-rentals/ts-z-calendar-client';

import { StyledEventPopover } from './StyledComponents';
import type { TourEvent, ZCalendarEvent } from '../../../../constants/TourCalendar';
import {
  getIsAvailabilityEvent,
  getIsInProgressAvailabilityEvent,
  getIsTourEvent,
} from '../../../../utils/calendarEventGetters';

export const getPopoverHeadingText = (event: ZCalendarEvent) => {
  if (getIsAvailabilityEvent(event)) {
    return 'Available';
  }
  if (getIsTourEvent(event)) {
    const tourEvent = event as TourEvent;
    if (tourEvent.tourStatus === TourStatusForZcheduler.REQUESTED) {
      return 'Tour request';
    }
    if (tourEvent.tourStatus === TourStatusForZcheduler.CONFIRMED) {
      return event.isPastEvent ? 'Past tour' : 'Booked tour';
    }
    if (tourEvent.tourStatus === TourStatusForZcheduler.EXPIRED) {
      return 'Request expired';
    }
    if (tourEvent.tourStatus === TourStatusForZcheduler.DECLINED) {
      return 'Declined tour';
    }
  }
  if (getIsInProgressAvailabilityEvent(event)) {
    return 'Add a time frame';
  }

  return '';
};

type CalendarEventPopperType = {
  event: ZCalendarEvent;
  popoverBody: React.ReactNode;
  onClose: () => void;
  modal?: boolean;
  children?: JSX.Element;
  isOpen?: boolean;
};

const CalendarEventPopper = ({
  event,
  popoverBody,
  onClose,
  modal = true,
  isOpen = true,
  children,
}: CalendarEventPopperType) => {
  return (
    <Popper
      triggered={
        <StyledEventPopover
          modal={modal}
          renderHeader={
            <Box css={{ display: 'flex', justifyContent: 'center' }}>
              <Heading level={5} css={{ fontSize: '16px' }}>
                {getPopoverHeadingText(event)}
              </Heading>
            </Box>
          }
          renderBody={popoverBody}
        />
      }
      isOpen={isOpen}
      onClose={onClose}
      placement="auto"
    >
      {children}
    </Popper>
  );
};

export default CalendarEventPopper;
